import { DialogDescription } from "@radix-ui/react-dialog";
import { FC, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useInventoryContext } from "../../../hooks/use-inventory";
import { CollectionsEnum } from "../../../lib/enums";
import { Category } from "../../../lib/types";
import {
  Dialog,
  DialogFooter,
  DialogHeader,
  DialogContent,
  DialogTitle,
  DialogClose,
  DialogTrigger,
  Button,
  Input
}
  from "../../../components/ui";
import { toast } from "sonner"


type CategoriesDialogProps = {
  isShowing: boolean,
  editItemId?: string,
  close: () => void
}

export const CategoryDialog: FC<CategoriesDialogProps> = ({
  isShowing,
  editItemId,
  close
}) => {



  const { getValues, register, formState, reset } = useForm()
  const { categories, updateInventoryElem, addInventoryElem } = useInventoryContext()

  useEffect(() => {
    if (editItemId) {
      const editItem = categories.find((c) => c.id === editItemId)

      if (editItem) {
        reset({
          name: editItem.name,
        })
      } else {
        toast.error("error trying to edit")
      }

    } else {
      reset({
        name: "",
      })
    }
  }, [editItemId])

  return (
    <Dialog
      open={isShowing}
      onOpenChange={close}
    >
      <DialogTrigger />
      <DialogContent className="dark:bg-neutral800 dark:border-neutral700">
        <DialogHeader>
          <DialogTitle className="dark:text-neutral100">{editItemId ? "Edit" : "Add"} Category</DialogTitle>
        </DialogHeader>
        <DialogDescription className="flex flex-col gap-2 dark:text-neutral300">
          <div className="text-sm font-semibold text-neutral700 dark:text-neutral300">
            What are we going to call this category:
          </div>
          <div className="w-full flex flex-col gap-2">
            <Input
              type="text"
              className="w-full"
              placeholder="category name"
              {...register("name", {
                required: true,
                maxLength: 30,
              })}
            />
          </div>
        </DialogDescription>
        <DialogFooter className="flex gap-2">
          <DialogClose>
            <Button
              variant="outline"
            >
              Cancel
            </Button>
          </DialogClose>
          <Button
            onClick={() => {
              const category = {
                name: getValues("name"),
              } as Category

              try {
                if (editItemId) {
                  category.id = editItemId
                  updateInventoryElem(category, CollectionsEnum.CATEGORY)
                  toast.success(`${category.name} updated`)
                } else {
                  addInventoryElem(category, CollectionsEnum.CATEGORY)
                  toast.success(`${category.name} added to categories`)
                }
              } catch (e) {
                console.error(e)
              }
              close()
            }}
            disabled={!formState.isValid}
          >
            {editItemId ? "Save Changes" : "Add Category"}
          </Button>

        </DialogFooter>
      </DialogContent>
    </Dialog>

  )
}
